// extracted by mini-css-extract-plugin
module.exports = {"container":"Welcome-module--container--37CcA"};